<template>
  <div class="home px-6 py-4">
    <div class="w-full flex flex-wrap">
      <div class="lists w-full md:w-3/4 mt-4 ">
        <div>
          <div class="day" v-if="sortPast.length > 0 ">
            <div class="date mb-8 flex items-baseline">
              <h4 class="font-extrabold text-2xl text-red-500 mr-4">
                Deadline Passed
              </h4>
              <span class="text-sm"></span>
            </div>
            <div>
              <todo-item
                v-for="todo in sortPast"
                :key="todo.id"
                :todo="todo"
                :activeId="activeId"
                @delete-todo="todoDelete($event)"
                @edit-todo="todoEdit($event)"
                @set-active="setActive($event)"
              />
            </div>
          </div>
        </div>
        <div>
          <div class="day" v-if="sortUpcoming.length > 0">
            <div class="date mb-8 flex items-baseline">
              <h4 class="font-extrabold text-2xl text-black mr-4">
                Upcoming Tasks
              </h4>
              <span class="text-sm"></span>
            </div>
            <div>
              <todo-item
                v-for="todo in sortUpcoming"
                :key="todo.id"
                :todo="todo"
                :activeId="activeId"
                @delete-todo="todoDelete($event)"
                @edit-todo="todoEdit($event)"
                @set-active="setActive($event)"
              />
            </div>
          </div>
          <empty v-else message="You do not have any upcoming todos"/>
        </div>
      </div>
      <div class=" w-full md:w-1/4 ">
        <div class="border border-gray-300 mt-8 mx-4">
          <div
            class="flex flex-col w-full rounded px-2 py-8 sticky"
            style="top: 70px"
          >
            <div v-if="!active">
              <img
                class="object-contain mb-2 mx-auto"
                src="https://res.cloudinary.com/lms-edc/image/upload/v1593818936/Assets/aporafx4d3ou5y8afima.png"
                alt=""
              />
              <div class="text-center mb-32 text-black text-lg">
                Click on a task to see more information about it here
              </div>
            </div>
            <div class="w-full" v-else>
              <div class="flex w-full justify-between">
                <h5 class="font-bold text-xl text-black">
                  Tasks
                </h5>
                <main class="w-full mt-1">
                  <span
                    @click="navigateEdit(activeId)"
                    id="edit"
                    class="cursor-pointer p-2 text-green-500"
                    ><i id="edit" class="fas fa-edit text-lg"></i>
                  </span>
                  <span
                    @click="todoDelete(activeId)"
                    id="delete"
                    class=" cursor-pointer p-2 text-red-500"
                    ><i id="delete" class="fas fa-trash-alt text-lg"></i>
                  </span>
                </main>
              </div>
              <p>{{ active.todo_text }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Empty from "../../../components/general/Empty";

export default {
  data() {
    return {
      done: true,
      active: null,
      activeId: null,
    };
  },
  components: {
    Empty,
    todoItem: () => import("@/components/learner/todo"),
  },
  computed: {
    ...mapGetters(["getTodos"]),
    sortPast() {
      let todos = this.getTodos;
      if (!todos) return [];
      let past = [];
      todos.forEach((todo) => {
        let d1 = new Date();
        let d2 = new Date(todo.due_date);
        if (d2 < d1) {
          // //console.log("jjjjjjhhhh");
          past.push(todo);
        }
      });
      return past;
    },
    sortUpcoming() {
      let todos = this.getTodos;
      if (!todos) return [];
      let upcoming = [];
      todos.forEach((todo) => {
        let d1 = new Date();
        let d2 = new Date(todo.due_date);
        if (d2 > d1) {
          upcoming.push(todo);
        }
      });
      return upcoming;
    },
  },
  methods: {
    ...mapActions(["deleteTodo", "fetchTodos", "updateTodo"]),
    navigateEdit(id) {
      this.$router.push({
        name: "learner-todo-edit",
        params: { id },
      });
    },
    async todoDelete(id) {
      let res = await this.deleteTodo({ id });
      if (res.status == 200 || res.status == 201) {
        this.fetchTodos();
        this.$Bus.$emit("notify", {
          type: "success",
          message: "Todo deleted successfully",
        });
        this.form = {};
      } else {
        if (res.status == 400) {
          this.$Bus.$emit("notify", {
            type: "error",
            message: res.data.errors
              ? res.data.errors[0].title
              : "An error occured",
          });
          this.$Bus.$emit("notify", {
            type: "error",
            message: "An error occured",
          });
        }
      }
    },
    async todoEdit(payload) {
      let res = await this.updateTodo({ ...payload });
      if (res.status == 200 || res.status == 201) {
        this.fetchTodos();
      } else {
        if (res.status == 400) {
          this.$Bus.$emit("notify", {
            type: "error",
            message: res.data.errors
              ? res.data.errors[0].title
              : "An error occured",
          });
          this.$Bus.$emit("notify", {
            type: "error",
            message: "An error occured",
          });
        }
      }
    },
    async setActive(payload) {
      this.activeId = payload.id;
      this.active = { ...payload };
    },
  },
  mounted() {
    this.fetchTodos();
  },
};
</script>
